import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { MdOutlineClose } from "react-icons/md";
import { FiPlus } from "react-icons/fi";
import { TbTrash } from "react-icons/tb";
import { useSelector } from 'react-redux';

const EditModal2 = ({ adminListForCust, userAccess, stateOptions, setIsEditModalData, isOpen, onClose, editData, handleOnChange, handleEditSubmit, error }) => {
  const [remarks, setRemarks] = useState(() => {
    if (typeof editData?.remark === 'string') {
      try {
        return JSON.parse(editData.remark) || [];
      } catch (e) {
        console.error('Invalid JSON:', e);
        return [];
      }
    }
    return editData?.remark || [];
  });
  const adminData = useSelector((state) => state.users.adminData);
  const adminType = adminData?.admin_type || "";

  const handleOnRemarkChange = (id, text) => {
    setRemarks((prev) => {
      const updatedRemark = prev.map((remark) => (remark.id === id ? { ...remark, text } : remark));

      const validRemarks = updatedRemark.filter(r => String(r?.text).length !== 0);
      setIsEditModalData((prevEditData) => ({
        ...prevEditData,
        remark: validRemarks?.map(e => ({ text: e.text, id: e.id })),
      }));
      return updatedRemark;
    });

    // const updatedRemarks = remarks.map((remark) =>
    //   remark.id === id ? { ...remark, text } : remark
    // );
    // setRemarks(updatedRemarks);
    // let validRemarks = remarks.filter(r => String(r.text || "").length !== 0);
    // let validRemark = [];
    // validRemarks.forEach(e => {
    //   validRemark.push({ text: e.text, id: e.id });
    // })
    // console.log("updatedRemarks", updatedRemarks, validRemark);
    // setIsEditModalData({ ...editData, remark: validRemark });
  };
  useEffect(() => {
    handleOnRemarkChange();
  }, [])

  const handleAddRemark = () => {
    setRemarks((prev) => [...prev, { id: prev.length + 1, text: "" }]);
  };

  const handleRemoveRemark = (id) => {
    setRemarks((prev) => prev.filter((remark) => remark.id !== id));
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-[1000px]  overflow-hidden overflow-y-auto ">

        <div className="flex justify-between items-center border-b py-2 md:px-6 px-4">
          <h2 className="text-xl font-semibold text-gray-800">Update Customer</h2>
          <button onClick={onClose} className="bg-gray-100 hover:bg-gray-200 p-2 rounded-full ">
            <MdOutlineClose size={20} className=' rounded-full' />
          </button>
        </div>
        <div className=' h-[30rem] overflow-y-auto'>
          <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2 md:p-6 p-4'>
            <div className="space-y-1 ">
              <label className="block text-sm  text-black">First Name *</label>
              <input
                type="text"
                id="name"
                name='f_name'
                value={editData?.f_name || null}
                onChange={handleOnChange}
                placeholder="First Name"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.f_name && <span className='text-sm text-red-500'>{error.f_name}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="l_name" className="block text-sm font-medium text-black">
                Last Name *
              </label>
              <input
                type="text"
                id="l_name"
                name='l_name'
                value={editData?.l_name || null}
                onChange={handleOnChange}
                placeholder="Last name"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.l_name && <span className='text-sm text-red-500'>{error.l_name}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="license_key" className="block text-sm font-medium text-black">
                License Key *
              </label>
              <InputMask
                mask="9999-9999-9999-9999"
                placeholder="0000-0000-0000-0000"
                value={editData?.license_key || 0}
                disabled={true}
              >
                {(inputProps) => (
                  <input
                    required
                    {...inputProps}
                    id="license_key"
                    type="text"
                    name='license_key'
                    disabled={true}
                    className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
                  />
                )}
              </InputMask>
            </div>

            <div className="space-y-1 ">
              <label htmlFor="weighbridge_id" className="block text-sm font-medium text-black">
                WeighBridge ID *
              </label>
              <input
                type="text"
                id="weighbridge_id"
                name='weighbridge_id'
                value={editData?.weighbridge_id || null}
                onChange={handleOnChange}
                // disabled={adminType === "admin"}
                disabled={!userAccess?.includes("expiry_cust_manag")}
                placeholder="Enter WeighBridge ID"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.weighbridge_id && <span className='text-sm text-red-500'>{error.weighbridge_id}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="date_of_birth" className="block text-sm font-medium text-black">
                Date Of Installation *
              </label>
              <input
                type="date"
                id="date_of_birth"
                name='date_of_birth'
                placeholder="Choose Date"
                value={editData?.date_of_birth || null}
                onChange={handleOnChange}
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.date_of_birth && <span className='text-sm text-red-500'>{error.date_of_birth}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="mac_address" className="block text-sm font-medium text-black">
                IP Address (System's) *
              </label>
              <input
                type="text"
                id="mac_address"
                name='mac_address'
                value={editData?.mac_address || null}
                onChange={handleOnChange}
                placeholder="MAC Address"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
            </div>

            <div className="space-y-1 ">
              <label htmlFor="expired_on" className="block text-sm font-medium text-black">
                Expiry Date *
              </label>
              <input
                type="date"
                id="expired_on"
                placeholder="Expiry Date"
                name='expired_on'
                value={editData?.expired_on || null}
                onChange={handleOnChange}
                // disabled={adminType==="admin"}
                disabled={!userAccess?.includes("expiry_cust_manag")}
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.expired_on && <span>{error.expired_on}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="address" className="block text-sm font-medium text-black">
                Address
              </label>
              <input
                type="text"
                id="address"
                name='address'
                value={editData?.address || null}
                onChange={handleOnChange}
                placeholder="Address"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
            </div>

            <div className="space-y-1 ">
              <label htmlFor="city" className="block text-sm font-medium text-black">
                City *
              </label>
              <input
                type="text"
                id="city"
                placeholder="City"
                name='city'
                value={editData?.city || null}
                onChange={handleOnChange}
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.city && <span className='text-sm text-red-500'>{error.city}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="state" className="block text-sm font-medium text-black">
                State *
              </label>
              <select
                id="state"
                name='state'
                value={editData?.state || null}
                onChange={handleOnChange}
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm">
                <option value={""}>State</option>
                {stateOptions.map(state => <option value={state}>{state}</option>)}
              </select>
              {error?.state && <span className='text-sm text-red-500'>{error.state}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="email" className="block text-sm font-medium text-black">
                Email
              </label>
              <input
                type="email"
                id="email"
                name='email'
                value={editData?.email || null}
                onChange={handleOnChange}
                placeholder="Email"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
            </div>

            <div className="space-y-1 ">
              <label htmlFor="phone" className="block text-sm font-medium text-black">
                Phone Number *
              </label>
              <input
                type="text"
                id="phone"
                name='phone'
                value={editData?.phone || null}
                onChange={handleOnChange}
                placeholder="Phone"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.phone && <span className='text-sm text-red-500'>{error.phone}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="referred_by_name" className="block text-sm font-medium text-black">
                Referral Name
              </label>
              <input
                type="text"
                id="referred_by_name"
                name='referred_by_name'
                value={editData?.referred_by_name || null}
                onChange={handleOnChange}
                placeholder="Referral Name"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.referred_by_name && <span className='text-sm text-red-500'>{error.referred_by_name}</span>}
            </div>

            <div className="space-y-1 ">
              <label htmlFor="referred_by_phone" className="block text-sm font-medium text-black">
                Referral Phone Number
              </label>
              <input
                type="text"
                id="referred_by_phone"
                name='referred_by_phone'
                value={editData?.referred_by_phone || null}
                onChange={handleOnChange}
                placeholder="Referral Phone"
                className="w-full  px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
              />
              {error?.referred_by_phone && <span className='text-sm text-red-500'>{error.referred_by_phone}</span>}
            </div>
            {adminType && adminType != "sub_admin" && <div className="">
              <label htmlFor="assign_admin_id" className="block text-sm font-medium text-black">
                Assign To Admin
              </label>
              <select id="assign_admin_id"
                name='assign_admin_id' value={editData?.assign_admin_id || null}
                onChange={handleOnChange} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm">
                {/* Need to add it for default selected candidate*/}
                <option value={null} >{"Select Admin"}</option>
                {adminListForCust?.map((e, i) => <option key={i} value={e.id}>{e.user_name}</option>)}
              </select>
            </div>}
          </div>

          <div className='px-6 pb-6 space-y-4'>
            <div className='flex items-center justify-between'>
              <p className="block text-base font-medium text-black">Remarks</p>
              <button type="button" onClick={handleAddRemark} className="flex items-center justify-end space-x-2 px-4 py-2 text-[#00923F] font-semibold rounded-md text-sm">
                <span><FiPlus className='w-5 h-5' /></span>
                <span className='uppercase'> Add remark</span>
              </button>
            </div>
            <div className="grid grid-cols-1 gap-3">
              {remarks && Array.isArray(remarks) && remarks?.map((remark, index) => (
                <div className='flex items-center space-x-2'>
                  <input type="remark" id="remark" name='remark' value={remark?.text || null} onChange={(e) => handleOnRemarkChange(remark.id, e.target.value)} placeholder="Remark" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
                  <button type="button" onClick={() => handleRemoveRemark(remark.id)} className="text-red-500 bg-red-100 flex items-center justify-center hover:bg-red-100 text-sm w-8 h-8 rounded-full">
                    <TbTrash />
                  </button>
                </div>))}
            </div>
          </div>
        </div>
        <div className="flex justify-end   border-t px-6 py-4 md:p-6 p-4">
          <button className="px-4 py-2 text-lg font-medium text-white bgbtn rounded-md transition md:w-40 w-full" onClick={handleEditSubmit}>
            Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditModal2;
